
import React from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';

const Contact = () => {
  return (
    <Container className="my-5">
      <Row>
        <Col md={6} className="mb-4">
          <h2>Contact Us</h2>
          <p>For inquiries, please feel free to reach out to us. We ensure utmost confidentiality.</p>
          <p><strong>Address:</strong> 123 Finance Avenue, Sydney, NSW 2000, Australia</p>
          <p><strong>Email:</strong> contact@lionshield.com.au</p>
          <p><strong>Phone:</strong> +61 2 1234 5678</p>
        </Col>
        <Col md={6}>
          <Form>
            <Form.Group className="mb-3" controlId="formGroupName">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formGroupEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formGroupMessage">
              <Form.Label>Message</Form.Label>
              <Form.Control as="textarea" rows={3} placeholder="Your message" />
            </Form.Group>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;
